import { useCallback, useMemo } from 'react';
import { useAppDispatch } from '../../store';
import { useAppState } from '../../store/appstate';
import {
    setThemeMode,
    toggleThemeMode,
    UserSettingsState,
} from '../../store/userSettings/userSettingsSlice';
import { walleyLightTheme, walleyDarkTheme, ThemeMode } from '../../theme/themes';
import Logger from '../logging/logger';

export const useThemeMode = () => {
    const dispatch = useAppDispatch();
    const { themeMode } = useAppState<UserSettingsState>(s => s.userSettings);

    const theme = useMemo(
        () => (themeMode === 'dark' ? walleyDarkTheme : walleyLightTheme),
        [themeMode]
    );

    const isDarkMode = themeMode === 'dark';

    const toggle = useCallback(() => {
        const newMode = themeMode === 'dark' ? 'light' : 'dark';
        Logger.information(`User changed theme mode from ${themeMode} to ${newMode}`);
        dispatch(toggleThemeMode());
    }, [dispatch, themeMode]);

    const setMode = useCallback(
        (mode: ThemeMode) => {
            Logger.information(`User changed theme mode from ${themeMode} to ${mode}`);
            dispatch(setThemeMode(mode));
        },
        [dispatch, themeMode]
    );

    return {
        themeMode,
        theme,
        isDarkMode,
        toggle,
        setMode,
    };
};

export default useThemeMode;
